/**
 * Normalizes the limited date formats emitted by `searchWidget.dateFormat`
 * to match the token style used by a given default format.
 *
 * This function is intended only for the D/M/Y-based formats produced by the
 * search widget. It is not a generic Moment.js format normalizer.
 *
 * The order of the date components from `raw` is preserved while month/year
 * token lengths and separators are normalized to match `defaultFormat`.
 *
 * @param {string|null|undefined} raw - Date format from `searchWidget.dateFormat`.
 * @param {string} defaultFormat - Moment.js format used by the current UI surface.
 * @returns {string} A normalized Moment.js format string.
 */
function normalizeSearchWidgetDateFormat(raw, defaultFormat) {
  if (!raw) return defaultFormat;

  let result = raw.toUpperCase();

  const targetSep = defaultFormat.includes('-') ? '-' : ' ';
  result = result.replace(/[-/\s]+/g, targetSep);

  const targetDay = defaultFormat.match(/DD|D/);
  if (targetDay) {
    result = result.replace(/DD|D/g, targetDay[0]);
  } else {
    result = result.replace(/DD|D/g, '');
  }

  const targetMonth = defaultFormat.match(/MMMM|MMM|MM/);
  if (targetMonth) {
    result = result.replace(/MMMM|MMM|MM/g, targetMonth[0]);
  }

  const targetYear = defaultFormat.match(/YYYY|YY/);
  if (targetYear) {
    result = result.replace(/YYYY|YY/g, targetYear[0]);
  } else {
    result = result.replace(/YYYY|YY/g, '');
  }

  const sepPattern = targetSep === '-' ? /-+/g : / +/g;
  result = result.replace(sepPattern, targetSep).replace(/^[-\s]+|[-\s]+$/g, '');

  return result.trim();
}

export default normalizeSearchWidgetDateFormat;
